import { Injectable } from '@angular/core';
import { PlayerType } from '../../../../../Common/model/player';
import { SettingsQuestions } from '../../../../../Common/model/player.settings';
import { PlayerSettingsUtil } from '../../../../../Common/util/player.settings.util';
import { DialogService } from '../../components/dialog/service/dialog.service';
import { ComponentCommunicationService } from '../componentcommunication/component-communication.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class NonLocalUserSettingsService {
  constructor(
    private userService: UserService,
    private dialogService: DialogService,
    private communicationService: ComponentCommunicationService,
  ) {}
  initialize() {
    this.communicationService.playerLoggedIn.subscribe(async (value) => {
      if (!value) {
        return;
      }
      const player = this.userService.getLoggedIn();
      if (player.type == PlayerType.Local) {
        return;
      }
      const playerSettings = this.userService.getPlayerSettings();
      if (PlayerSettingsUtil.hasSettingsQuestionBeenDismissed(playerSettings, SettingsQuestions.UpdateUserNameForNonLocalUser)) {
        return;
      }
      const newUserName = await this.dialogService.showChangeUserNameDialog(player.name);
      playerSettings.settingsQuestionsDismissed.push(SettingsQuestions.UpdateUserNameForNonLocalUser);
      this.dialogService.wrapInProgress(async () => {
        await this.userService.savePlayerSettings();
        if (newUserName == null) {
          return;
        }
        await this.userService.updatePlayer({ ...player, name: newUserName });
      });
    });
  }
}
